/**
 * App.jsx — Rê Leve IA (Etapa 3B)
 * Dois modos de visualização:
 *   "client"    → Site do cliente (experiência pública)
 *   "developer" → Janela do desenvolvedor (laboratório técnico)
 */

import { useEffect, useState } from 'react';
import './styles.css';
import './alma-mostarda.css'; // Alma Mostarda Vibrante (decisão Rounds 01v2→04) — vence cascade
import './operator-panels.css'; // Janela do Operador (Marketing/Operação/Técnico)
import Layout from './components/Layout';
import ClientSiteView from './components/ClientSiteView';
import OperatorWindow from './components/OperatorWindow';
import ApiWakeupSplash from './components/ApiWakeupSplash';
import AdminView from './components/AdminView';

function readModeFromURL() {
  if (typeof window === 'undefined') return 'client';
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('mode');
  if (mode === 'admin') return 'admin';
  if (mode === 'developer') return 'developer';
  if (mode === 'client') return 'client';
  // Detecção de retorno do Stripe
  const payment = params.get('payment');
  if (payment === 'success' || payment === 'cancel') return 'client';
  return 'client';
}

export default function App() {
  const [viewMode, setViewMode] = useState(readModeFromURL);

  useEffect(() => {
    // Sincroniza URL com viewMode quando muda
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    if (viewMode === 'client') {
      url.searchParams.delete('mode');
    } else {
      url.searchParams.set('mode', viewMode);
    }
    window.history.replaceState({}, '', url);
  }, [viewMode]);

  if (viewMode === 'admin') {
    return (
      <Layout>
        <AdminView onExit={() => setViewMode('client')} />
      </Layout>
    );
  }

  return (
    <Layout>
      {/* Splash discreto quando API Render dorme */}
      <ApiWakeupSplash />

      {/* Barra de alternância de modo */}
      <div className="mode-switcher">
        <div className="mode-switcher-inner">
          <span className="mode-switcher-label">Modo de visualização:</span>
          <div className="mode-buttons">
            <button
              className={`mode-btn ${viewMode === 'client' ? 'mode-btn--active' : ''}`}
              onClick={() => setViewMode('client')}
            >
              🛍️ Ver site do cliente
            </button>
            <button
              className={`mode-btn ${viewMode === 'developer' ? 'mode-btn--active mode-btn--dev' : ''}`}
              onClick={() => setViewMode('developer')}
            >
              🔬 Janela do Operador
            </button>
          </div>
          <span className="mode-current">
            {viewMode === 'client'
              ? 'Exibindo: experiência pública do cliente'
              : 'Exibindo: marketing + operação + painel técnico'}
          </span>
        </div>
      </div>

      {/* Renderização condicional por modo com fade suave */}
      <div className="view-fade" key={viewMode}>
        {viewMode === 'client' ? (
          <ClientSiteView simCustomer={null} />
        ) : (
          <OperatorWindow onExit={() => setViewMode('client')} />
        )}
      </div>
    </Layout>
  );
}
